/**
 * Returns the correct height of the spotify embed depending on the link
 */
export const getSpotifyEmbedHeight = (spotifyLink?: string) => {
    if (!spotifyLink) return 80
    const regex = new RegExp(/open.spotify.com\/((episode)|(show)|(artist))\//)
    const match = regex.exec(spotifyLink)
    return match == null ? 80 : null
}
